<template>
    <span v-if="gps == null || gps == 'undefined'">
        _
    </span>
    <span v-else-if="!Number.isInteger(gps)">
        {{ gps }}
    </span>
    <span v-else-if="gps >= 10" class="ui-badge status-badge--ok">
        <font-awesome-icon :icon="['fas', 'globe']" class="me-1"/> {{ gps }} sat
    </span>
    <span v-else-if="gps >= 5" class="ui-badge status-badge--medium">
        <font-awesome-icon :icon="['fas', 'globe']" class="me-1"/> {{ gps }} sat
    </span>
    <span v-else class="ui-badge status-badge--low">
        <font-awesome-icon :icon="['fas', 'globe']" class="me-1"/> {{ gps }} sat
    </span>
</template>

<script>
export default {
  props: ['gps']
}
</script>